const validEvents = [
  'page_view',
  'Watch Now Button',
  'add_to_mylist',
  'remove_from_mylist',
  'search',
  'share',
  'add_to_wishlist',
  'content_vod_start',
  'content_live_start',
  'category_view',
]

export const sendGoogleTagEvent = (event, detail = {}) => {
  if (window.dataLayer && typeof window.dataLayer === 'object') {
    if (validEvents.includes(event)) {
      window.dataLayer.push({
        event,
        ...detail,
      })
    } else {
      console.error(`>>> Invalid google tag managerevent: ${event}`) // eslint-disable-line no-console
    }
  }
}
export const sendNestedGoogleTagEvent = (event, detail = {}) => {
  if (window.parent.dataLayer && typeof window.parent.dataLayer === 'object') {
    if (validEvents.includes(event)) {
      window.parent.dataLayer.push({
        event,
        ...detail,
      })
    } else {
      console.error(`>>> Invalid google tag managerevent: ${event}`) // eslint-disable-line no-console
    }
  }
}

export default {
  sendGoogleTagEvent,
}
